import React from 'react';
import styled from 'styled-components';
import Phytoplankton from '../../components/Phytoplankton/Phytoplankton';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardPhytoplankton extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Phytoplankton />

    </Viz>

   <ReusableDetailCard
   trend= {Target}
   metricsm="Prevalent Worldwide"
   diagnosis="Phytoplankton are microscopic marine algae. They are the basis of the marine food web, providing nutrients for a wide range of sea creatures including whales, shrimp, snails, and jellyfish."
   prediction="Agricultural runoff causes phytoplankton to grow out of control and form harmful algal blooms (HABs). Additionally, Phytoplankton attach to contaminated plastics, which carry toxic pollutants up the food web (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardPhytoplankton;
